export const PROGRAM_VARIANTS = `
  query programVariants($filter: FilterProgramVariantInput, $skip: Int, $take: Int, $tenant_id: Int!) {
    programVariants(filter: $filter, skip: $skip, take: $take, tenant_id: $tenant_id) {
      id
      name
      link
      program_category_id
      category {
        id
        name
      } 
      description
      active
      scope
      restricted_visibility
      visible_group_ids
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
    }
  }
`;

export const PROGRAM_VARIANT = `
  query programVariant($id: Int!, $tenant_id: Int!) {
    programVariant(id: $id, tenant_id: $tenant_id) {
      id
      name
      link
      program_category_id
      category {
        id
        name
      }
      description
      active
      scope
      restricted_visibility
      visible_group_ids
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
    }
  }
`;

export const ENTRY_FORM_PROGRAM_VARIANTS = `
  query entryFormProgramVariants($filter: FilterProgramVariantInput, $skip: Int, $take: Int, $tenant_id: Int!) {
    entryFormProgramVariants(filter: $filter, skip: $skip, take: $take, tenant_id: $tenant_id) {
      id
      name
      link
      program_category_id
      category {
        id
        name
      }
      description
      active
      scope
      restricted_visibility
      visible_group_ids
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
    }
  }
`;
